import { UIEditorBlockWidth } from '@lmt/unicorn-shared/app/components/editor/components/blocks/WidthSelectControl';
import React, { ReactNode } from 'react';

import styles from './UIEditorBlocks.module.scss';

export const BlockContainer: React.FC<{
  size: UIEditorBlockWidth;
  children?: ReactNode;
  testId?: string;
  unicornField?: string;
}> = (props) => {
  return (
    <div
      className={styles.container}
      style={{
        width: props.size,
      }}
      data-app-field={props.unicornField}
      data-test-id={props.testId}
    >
      <div className={styles.elementContainer}>{props.children}</div>
    </div>
  );
};
